<template>
	<nut-navbar
		class="navbar"
		title="激活设备"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<nut-icon
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
				@click="handleOpenDialog(ACTIVATION_HELP)"
			>
			</nut-icon>
		</template>
	</nut-navbar>
	<div>
		<div class="card">
			<div class="title">
				<nut-divider>方法1: 激活码激活</nut-divider>
			</div>
			<div class="valid-container">
				<input
					id="vcode"
					class="input-valid"
					maxlength="4"
					type="tel"
					v-model="inputVal"
					@focus="inputFocused = true"
					@blur="inputFocused = false"
				/>
				<label
					for="vcode"
					class="line"
					v-for="(item, index) in codeLength"
					:key="index"
					:class="{
						animated: inputFocused && currentCursorIndex === index,
					}"
					v-text="inputValString[index]"
				>
				</label>
			</div>
			<div class="tip">请输入设备屏幕上的4位激活数字码！</div>
			<nut-button
				:disabled="btnDisabled"
				type="primary"
				block
				@click="handleActivate"
				>立即激活</nut-button
			>
		</div>
		<div class="card">
			<div class="title">
				<nut-divider>方法2: 扫码激活</nut-divider>
			</div>
			<img
				@click="handleScan"
				class="scan"
				src="https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/scan.png"
				alt=""
			/>
			<div class="tip">点击后扫描设备屏幕上二维码完成激活！</div>
		</div>
	</div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { Toast } from '@nutui/nutui';
import wx from 'weixin-js-sdk';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import { activationApi, siteApi } from '@/apis';
import { ACTIVATION_HELP } from '@/constants/tiptype';
import { getConfigUrl } from '@/utils/util';

export default {
	name: 'Activation',
	components: {},
	setup() {
		const { goBack, push } = useNavigate();
		const { handleOpenDialog } = useDialog();
		const inputFocused = ref(false);
		const inputVal = ref('');
		const codeLength = 4;
		const currentCursorIndex = computed(() => inputVal.value.length);

		const inputValString = computed(() => inputVal.value);

		const btnDisabled = computed(
			() => inputValString.value.length !== codeLength
		);

		const getData = async () => {
			const url = getConfigUrl();
			const res = await activationApi.activation_loaddata({
				url,
			});

			const { debug, appId, timestamp, nonceStr, signature, jsApiList } =
				res;
			wx.config({
				debug,
				appId,
				timestamp,
				nonceStr,
				signature,
				jsApiList,
			});
		};

		const handleActivate = async () => {
			await activationApi.activation_code_bind({
				code: inputValString.value,
			});
			Toast.success('激活成功', {
				duration: 1000,
				onClose() {
					push('/home');
				},
			});
		};
		const handleScan = () => {
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				scanType: ['qrCode'],
				success: async (res) => {
					const code = res.resultStr;
					await activationApi.activation_scan_bind({
						code,
					});
					Toast.success('激活成功', {
						duration: 1000,
						onClose() {
							push('/home');
						},
					});
				},
				fail: (err) => {
					// 上报扫码调用失败
					siteApi.ajax_error({
						result: err.errMsg,
					});
				},
			});
		};

		onMounted(() => {
			getData();
		});
		return {
			inputVal,
			inputValString,
			inputFocused,
			codeLength,
			currentCursorIndex,
			ACTIVATION_HELP,
			btnDisabled,
			goBack,
			handleOpenDialog,
			handleActivate,
			handleScan,
		};
	},
};
</script>

<style lang="scss" scoped>
@keyframes coruscate {
	0% {
		opacity: 0;
	}
	25% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	75% {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
}
.card {
	padding: 20px 15px;
	font-size: 12px;
	.title {
		width: 70%;
		margin: 0 auto;
	}
	.valid-container {
		position: relative;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;

		.input-valid {
			position: absolute;
			height: 0;
		}
		.line {
			position: relative;
			width: 20%;
			height: 48px;
			line-height: 48px;
			text-align: center;
			font-size: 24px;
			border-bottom: 1px solid #ddd;
			&.animated::before {
				display: block;
				position: absolute;
				left: 50%;
				top: 35%;
				width: 1px;
				height: 40%;
				content: '';
				background-color: #2e2f33;
				animation-name: coruscate;
				animation-duration: 1s;
				animation-iteration-count: infinite;
				animation-fill-mode: both;
			}
		}
	}

	.tip {
		margin: 20px 0;
		font-size: 12px;
		color: #999;
		text-align: center;
	}

	.scan {
		display: block;
		margin: 0 auto;
		width: 80px;
		height: 80px;
	}
}
</style>
